import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import { getTabclixCode } from "../../helpers/embed-code";
import { v4 as uuid } from 'uuid';
import { useTracking } from 'react-tracking';
import axios from "axios";
import { useSelector } from 'react-redux';


function ConfigWrapper(props) {

  const paymentMethod = useSelector(state => state.datareducer.payment);
  const [stripeObject, setStripeObject] = useState(null);
  const { trackEvent } = useTracking();

  useEffect(() => {

    // if there is a payment form it means there will be payment,
    // just loop and see if present then proceed
    // if not set variable to zero and will return with empty stipe element

    let code = getTabclixCode();
    // localStorage.removeItem(`__trEventSs_${code}`);
    try {

      if (!localStorage.getItem(`__trEventSs_${code}`)) {
        localStorage.setItem(`__trEventSs_${code}`, JSON.stringify(uuid()));

        axios
          .get("https://ipapi.co/json/")
          .then((response) => {
            let data = response.data;
            trackEvent({
              TrackingType: 'userLocationEvent',
              Trackcountry: data.country_name,
              TrackCity: data.city,
              TrackIp: data.ip,
              TrackRegionCode: data.region_code,
              TrackCurrency: data.currency,
              TrackLatitudeLongitude: `${data.latitude};${data.longitude}`,

            })
          })
          .catch((error) => {
            // console.log(error);
          });
      }
    } catch (e) {
      // console.log(e);
    }

    if (paymentMethod.active_pay_method !== "stripe") {

      const fetchStripeObject = async () => {

        let userToken = getTabclixCode();

        try {
          const stripekey = await fetch(
            `${process.env.REACT_APP_CMS_URL}/api/stripe-pubkey`, {
            method: "get",
            headers: {
              data: `${userToken}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
          );

          const userStripeKey = await stripekey.text();
          const res = await loadStripe(String(userStripeKey));
          setStripeObject(res);

        } catch (error) {
          return <>{props.children}</>;
        }

        if (!stripeObject) {
          return <>{props.children}</>;
        }
      };
      fetchStripeObject();
    }

  }, []);

  return (
    <Elements stripe={stripeObject}>
      <>{props.children}</>
    </Elements>
  );
}

export default ConfigWrapper;
